<div class="header">
    <div class="title" trans>General</div>
    <div class="subtitle" trans>Configure general site settings.</div>
</div>

<form class="body many-inputs" (ngSubmit)="saveSettings()" ngNativeValidate>
    <div class="input-container">
        <label for="app_url" trans>Site Url</label>
        <input type="text" id="app_url" name="app_url" [(ngModel)]="state.server['app_url']" readonly="readonly" required>
    </div>

    <div class="input-container">
        <label for="homepage.type" trans>Homepage Type</label>
        <select name="homepage.type" id="homepage.type" [(ngModel)]="state.client['homepage.type']" (ngModelChange)="setHomepageValue()">
            <option value="default">Default</option>
            <option value="component">Application Page</option>
            <option value="page">Custom Page</option>
        </select>
        <p trans>Type of the homepage.</p>
    </div>

    <div class="input-container" *ngIf="state.client['homepage.type'] === 'page'">
        <label for="homepage.value" trans>Custom Page Name</label>
        <input type="text" [formControl]="customPageSearch" [matAutocomplete]="auto" placeholder="Search..." trans-placeholder required>
        <p trans>Select a custom page that should be used for homepage.</p>

        <mat-autocomplete #auto="matAutocomplete">
            <mat-option *ngFor="let page of filteredCustomPages | async" [value]="page.slug">{{page.slug}}</mat-option>
        </mat-autocomplete>
    </div>

    <div class="input-container" *ngIf="state.client['homepage.type'] === 'component'">
        <label for="homepage.value" trans>Application Page</label>
        <select name="homepage.value" id="homepage.value" [(ngModel)]="state.client['homepage.value']">
            <option [ngValue]="route.path" *ngFor="let route of getHomepageComponents()" trans>{{getDisplayName(route.path)}}</option>
        </select>
        <p trans>Select application page that should be used for homepage.</p>
    </div>

    <div class="setting-toggle-container">
        <mat-slide-toggle name="branding.use_custom_theme" id="branding.use_custom_theme" [(ngModel)]="state.client['branding.use_custom_theme']" trans>
            Custom Theme
        </mat-slide-toggle>
        <p trans>Enable custom theme (generated via appearance editor).</p>
    </div>

    <div class="setting-toggle-container">
        <mat-slide-toggle name="site.force_https" id="site.force_https" [(ngModel)]="state.client['site.force_https']" trans>
            Redirect to HTTPS
        </mat-slide-toggle>
        <p trans>You must have SSL set up on the server for this to work.</p>
    </div>

    <button mat-raised-button color="accent" class="button primary update-button" type="submit" [disabled]="loading" trans>Update</button>
</form>